<script>
    import { fade } from 'svelte/transition';
    import { push } from 'svelte-spa-router';
    import { onMount } from 'svelte';
    import fetchData from '../../api.js';
    import UserStore from '../../stores/user';
    import { cartsStore } from '../../stores/cartStore';
    import { _ } from "svelte-i18n";

    import Header from '../../components/Header.svelte'; 
    import TopInfo from '../../components/TopInfo.svelte';  
    import Preloader from '../../components/Preloader.svelte'; 

    export let params; 

    let isLoading = false;
    
    let cart = {
        customer_name : ''
    };
    let carts = {};
    let showCustomerSearch = false;
    let customerSearch = '';
    let customersResults = [];
    let isSearchingCustomer = false;


    $: total = cart?.items?.reduce(
        (sum, item) => sum + (item.price_after_discount * item.quantity),
        0
    );

    $: totalBeforeVat = total / 1.18;
    $: vatAmount = total - totalBeforeVat;

    $: cart_id = params?.cart_id ? params.cart_id : null;

    $: if (cart_id) {
        fetchCart(cart_id);
    }

    function getCartItemImage(item) {
        return item.colorImages?.find((image) => image.color === item.color)?.image_url
            || item.image_url
            || item.colorImages?.[0]?.image_url
            || '';
    }


    $: groupedCart = Object.values(
        (cart?.items || []).reduce((acc, item) => {

            const key = `${item.parent_id || item.sku}__${item.color || ''}`;

            if (!acc[key]) {
                acc[key] = {
                    parent_id: item.parent_id || item.sku,
                    color: item.color || '',
                    image_url: getCartItemImage(item),
                    name: item.parent_sku|| item.sku,
                    variants: []
                };
            }

            acc[key].variants.push(item);

            return acc;

        }, {})
    );




    onMount(async () => {
        if (!$UserStore || !$UserStore.data) {
            push('/login');
            return;
        }       

        fetchCart()
    });


    async function fetchCart() {

        isLoading = true;

        let postData = {
            action : 'agents_get_carts',
            token : $UserStore.data
        }
        let response = await fetchData(postData);
        carts = response?.data || {};
        cartsStore.set(carts);

        postData = {
            action : 'agents_get_cart',
            token : $UserStore.data,
            cart_id : cart_id
        }
        response = await fetchData(postData);
        cart = response?.data || {};


        isLoading = false;


    }

    

    async function updateQty(item, qty) {

        isLoading = true;

        let postData = {
            sku : item.sku,
            quantity: qty,
            store: item.store,
            name: item.name,
            price: item.price,
            price_before_discount: item.price_before_discount,
            product_id: item.product_id,
            parent_id : item.parent_id,
            parent_sku : item.parent_sku,
            action : 'agents_cart_add',
            token : $UserStore.data,
            cart_id : cart.id
        }

        const response = await fetchData(postData);

        cart = response.data;

        isLoading = false;
    }

    async function removeItem(item) {


        isLoading = true;

        let postData = {
            action : 'agents_remove_cart_item',
            token : $UserStore.data,
            item_id : item.id
        }

        try {
            let response = await fetchData(postData);   
            carts[cart_id].items = cart.items.filter(i => i.id !== item.id);         
            cartsStore.set(carts);
            cart = carts[cart_id];


        } catch (e) {
            console.error(e);
        }

        isLoading = false;
    }

    async function finishOrder() {

        if (cart.customer_id == null || cart.customer_id == '') {
            alert($_('agents.cart.select_customer_alert'));
            return;
        }

        isLoading = true;
        
        let postData = {
            action : 'agents_finish_cart',
            token : $UserStore.data,
            cart_id : cart_id,
            order_user_name : ($UserStore?.agent_name || '').trim()
        }

        try {
            let response = await fetchData(postData);   

            if (response.success==1) {
                alert($_('agents.cart.order_finished'));
                push('/agents/products/');
            } else {
                alert($_('agents.cart.order_failed'));
            }

        } catch (e) {
            console.error(e);
        }

        isLoading = false;
    }


    let searchTimeout;

    async function searchCustomers() {
        clearTimeout(searchTimeout);

        if (!customerSearch || customerSearch.length < 2) {
            customersResults = [];
            return;
        }

        searchTimeout = setTimeout(async () => {

            isSearchingCustomer = true;

            try {

                let postData = {
                    action : 'agents_search_customers',
                    token : $UserStore.data,
                    q : customerSearch
                }

                const response = await fetchData(postData);

                customersResults = response?.data || [];

            } catch (e) {
                console.error(e);
            }

            isSearchingCustomer = false;

        }, 400);
    }

    async function selectCustomer(customer) {

        try {
            let postData = {
                action : 'agents_add_customer_to_cart',
                token : $UserStore.data,
                customer : customer,
                cart_id : cart.id
            }

            const response = await fetchData(postData);
            // update local UI
            cart.customer_name = customer.CustomerName;
            cart.customer_id = customer.CustomerNo;
            cart.customer_discount = customer.DiscountPercent;

            showCustomerSearch = false;
            customerSearch = '';
            customersResults = [];

            fetchCart();

        } catch (e) {
            console.error(e);
        }
    }

    async function deleteCart() {
        if (!confirm($_('agents.cart.confirm_delete') || 'Delete this cart?')) return;
        isLoading = true;

        try {
            let postData = {
                action: 'agents_delete_cart',
                token: $UserStore.data,
                cart_id: cart.id
            }

            const response = await fetchData(postData);
            if (response && response.success) {
                if (carts && carts[cart.id]) {
                    delete carts[cart.id];
                    cartsStore.set(carts);
                }
                push('/agents/carts');
            } else {
                alert($_('agents.cart.delete_failed') || 'Failed to delete cart');
            }

        } catch (e) {
            console.error(e);
        }

        isLoading = false;
    }



</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading} />
    <Header />

    <div class="page">
        <TopInfo />

        <div class="shipment">
            <h1 class="pb-2 font-bold text-[16px]">{$_('agents.cart.name')}</h1>
            <h3 class="pb-2 font-bold">
                {$_('agents.cart.customer_name')}: {cart.customer_name} <span class="font-normal">({$_('agents.cart.discount')}:{cart.customer_discount}%)</span>
                {#if cart.order_number == null}
                    <button
                        class="text-blue-500 text-sm underline"
                        on:click={() => showCustomerSearch = !showCustomerSearch}
                    >
                        {$_('agents.cart.change')}
                    </button>

                    {#if isSearchingCustomer}
                        <div class="text-xs text-gray-400 mt-1">{$_('agents.cart.searching')}</div>
                    {/if}
                {/if}

            </h3>

            {#if showCustomerSearch}
                <div class="relative my-2">

                    <input
                        type="text"
                        placeholder="{$_('agents.cart.search_customers')}"
                        class="border rounded p-2 w-full border-gray-500"
                        bind:value={customerSearch}
                        on:input={searchCustomers}
                    />

                    {#if customersResults.length}
                        <div class="absolute bg-white shadow-lg w-full rounded mt-1 max-h-60 overflow-auto z-50">
                            {#each customersResults as customer}
                                <div
                                    class="p-2 hover:bg-gray-100 cursor-pointer"
                                    on:click={() => selectCustomer(customer)}
                                >
                                    <strong>{customer.CustomerName}</strong>
                                    <div class="text-xs text-gray-500">
                                        {customer.CustomerNo} - {customer.CellPhone} / {customer.Tel1}
                                    </div>
                                </div>
                            {/each}
                        </div>
                    {/if}

                </div>
            {/if}


            <h4 class="pb-2 font-bold">{$_('agents.cart.date')}: {cart.date_time}</h4>

            {#if cart.order_number == null}
            <div class="mb-4 font-bold bg-green-400 text-black rounded px-3 py-1 cursor-pointer inline-block" on:click={()=>push('/agents/products/' + cart.id)}>
                {$_('agents.cart.add')} +
            </div>
            <button
                class="mb-4 ml-3 font-bold bg-red-500 text-white rounded px-3 py-1 cursor-pointer inline-block"
                on:click={deleteCart}
            >
                {$_('agents.cart.delete') || 'Delete'}
            </button>
            {/if}

            {#if cart && cart.items && cart.items.length}
                <div class="cart-items py-3">
                    {#each groupedCart as product}

                    <div class="cart-item border p-2 justify-start items-center gap-2 relative mb-[10px]">

                        <div class="info bg-white text-[11px] absolute top-[-12px] right-[10px] border-1 p-1 pb-0">
                            {product.name}
                        </div>

                        <!-- Parent Product Header -->
                        <div class="flex gap-2 items-center flex-col">

                            <div class="w-16 h-16">
                                <img
                                    src={product.image_url}
                                    class="w-16 h-16 object-cover"
                                    alt={product.name}
                                />
                            </div>
                            

                        </div>

                        <div class="flex flex-col">
                        <!-- Variants List -->
                        {#each product.variants as item}

                            <div class="flex justify-between items-center py-1 last:border-b-0 gap-2 text-[12px]">

                                <div class="info flex gap-2">
                                    <div class="name">{item.sku}</div>
                                    <div class="variant">{item.name}</div>
                                    <div>{$_('agents.products.size')}: {item.size}</div>
                                    <div>{$_('agents.products.color')}:{item.color}</div>

                                    <div class="price text-black font-bold">
                                        {#if item.price_after_discount && item.price_after_discount < item.price}
                                            ₪{item.price_after_discount}
                                            <u class="line-through font-normal text-gray-400">₪{item.price}</u>
                                        {:else}
                                            ₪{item.price}
                                        {/if}
                                    </div>

                                    <div>   
                                        {#if item.price_before_discount && item.price_before_discount != item.price}
                                            <span class="text-xs">
                                                ({$_('agents.cart.customer_price')}: ₪{item.price_before_discount})
                                            </span>
                                        {/if}
                                    </div>

                                    <div class="store">
                                        {$_('agents.products.store')}: {item.store}
                                    </div>
                                </div>

                                {#if cart.order_number == null}
                                <div class="actions flex gap-2">

                                    <input
                                        type="number"
                                        min="1"
                                        value={item.quantity}
                                        on:change={(e) => updateQty(item, +e.target.value)}
                                        class="w-16 border rounded"
                                    />

                                    <button
                                        class="bg-red-500 text-white rounded px-2 py-1 text-[14px]"
                                        on:click={() => removeItem(item)}
                                    >
                                        ✕
                                    </button>

                                </div>
                                {/if}

                                <div class="font-bold">
                                    {$_('agents.cart.total_item_amount')}: ₪{item.price_after_discount * item.quantity}
                                </div>

                            </div>

                        {/each}
                        </div>

                    </div>

                {/each}

                </div>

                <div class="summary bg-grey border flex p-3 gap-3 justify-between">
                    <div class="flex-col">
                        <div><b>{$_('agents.cart.total_before_vat')}:</b> ₪{totalBeforeVat.toFixed(2)}</div>
                        <div><b>{$_('agents.cart.vat')} (18%):</b> ₪{vatAmount.toFixed(2)}</div>
                        <div><b>{$_('agents.cart.total')}:</b> ₪{total.toFixed(2)}</div>
                    </div>
                    {#if cart.order_number == null}
                    <button class="finish bg-black text-white rounded px-4 py-2" on:click={finishOrder}>
                        {$_('agents.cart.finish')}
                    </button>
                    {/if}
                </div>
            {:else}
                <p>{$_('agents.cart.empty')}</p>
            {/if}
        </div>
    </div>
</div>

<style>
    .cart-items {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-bottom: 15px;
    }

    .cart-item {
        display: flex;
        padding: 10px;
        align-items: center;
    }


    .name {
        font-weight: bold;
    }


    .actions {
        display: flex;
        gap: 5px;
        align-items: center;
    }

    input[type="number"] {
        width: 60px;
        padding: 4px;
    }


    .finish {
        padding: 8px 15px;
        font-weight: bold;
    }

    .border {
        border: 1px solid #efefef;
    }
</style>
